import _ from 'underscore';
import React, { useCallback, useState } from 'react';
import { Input, InputProps, mergeClasses } from '@fluentui/react-components';
import { SearchRegular } from '@fluentui/react-icons';
import { useDataSource } from '@bingads-webui-react/data-source';

const DEBOUNCE_DELAY = 250;

interface InternalSearchBoxProps {
  inputRef?: React.Ref<HTMLInputElement>;
}

export type EntitySelectorSearchBoxProps = Omit<InputProps, 'value' | 'contentBefore'> & InternalSearchBoxProps;

export const InternalSearchBox = (
  {
    onChange, inputRef, className, ...props
  }: EntitySelectorSearchBoxProps,
  ref: React.Ref<HTMLInputElement>,
) => {
  const { searchTerm, search } = useDataSource();
  const [internalSearchTerm, setInternalSearchTerm] = useState(searchTerm);

  const debouncedSearch = useCallback(_.debounce(search, DEBOUNCE_DELAY), [search]);

  const internalOnChange: InputProps['onChange'] = useCallback((e, data) => {
    setInternalSearchTerm(data.value);
    onChange?.(e, data);

    debouncedSearch(data.value);
  }, [debouncedSearch, onChange]);

  return (
    <Input
      {...props}
      ref={ref}
      input={{ ref: inputRef }}
      className={mergeClasses('search-box', className)}
      contentBefore={<SearchRegular />}
      value={internalSearchTerm}
      onChange={internalOnChange}
    />
  );
};

export const SearchBox = React.forwardRef(InternalSearchBox);
